<template>
	<AppDialog
		disableMaxWidth
		width="770"
		disableClose
		:closeTop="'-30'"
		:closeRight="'-10'"
		class="app-dialog-wrapper"
		dialogName="CantDeleteUsedEmailTemplateDialog"
	>
		<Col class="dialog-content-container overflow-hidden pt-6 px-5 pb-5 flex-justify-space-between">
			<Col class="overflow-y-auto">
				<h1 class="size-22 font-weight-700 bold mb-2">You cannot delete a template used in active features</h1>
				<Col>
					<div class="font-size-lg font-weight-400 mb-2">Deactivate the features or republish them without the template to delete.</div>
					<Col class="feature-container mt-6">
						<Col>
							<div class="font-size-lg font-weight-700">{{ numOfFeaturesUsed }} active features with this template:</div>
							<Row class="flex-justify-space-between mt-3" v-for="id in featureIds" :key="`feature_id_${id}`">
								<div class="">Feature {{ id }}</div>
								<AnemicButton class="open-feature" @click="openFeature(id)">Open feature</AnemicButton>
							</Row>
						</Col>
					</Col>
				</Col>
			</Col>
			<Col class="mt-5">
				<Row class="flex-centerize">
					<PrimaryButton class="got-it" @click="close">Got it</PrimaryButton>
				</Row>
			</Col>
		</Col>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

export default {
	name: 'CantDeleteUsedEmailTemplateDialog',
	components: { AppDialog },
	props: { dialogPromiseHandlers: { type: Object }, usedInWorkflowsInfo: { type: Object } },
	computed: {
		numOfFeaturesUsed() {
			return this.usedInWorkflowsInfo.count;
		},
		featureIds() {
			return this.usedInWorkflowsInfo.ids;
		},
	},
	methods: {
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
		openFeature(featureId) {
			const featureDetailsUrl = `${window.location.origin}/feature-details/${featureId}`;
			window.open(featureDetailsUrl, '_blank');
		},
	},
};
</script>

<style scoped lang="scss">
.dialog-content-container {
	width: 770px;
	min-height: 530px;
	max-height: 80vh;
	border-radius: 9px;
	background: #ffffff;
	border: 1px solid #e8ecf3;
	.size-22 {
		font-size: 22px;
	}
	.open-feature {
		padding: 6px 7px;
		border: solid 1px #d9d9d9;
		background-color: white !important;
		min-width: 80px;
		text-align: center;
		font-size: 12px !important;
		font-weight: 400 !important;
		&.edit {
			width: 80px;
		}
	}
	.got-it {
		width: 80px;
	}
}
</style>
